// Navigation + tools-menu strings for the global nav (GlobalNav in
// DirectorShell), split out of newLanding.ts so the site-wide header can stay
// in the entry bundle while the rest of the landing copy (~90KB across 14
// languages) loads lazily with the pages that use it. Positional arrays match
// navKeys/toolKeys order, same as the make() convention in newLanding.ts.

export const navKeys = [
  "tools",
  "createSong",
  "createMusicVideo",
  "library",
  "pricing",
  "blog",
  "upgrade",
  "addOnCredits",
  "creditUsageDetails",
  "myProfile",
  "manageSubscription",
  "logout",
  "signIn",
  "getStarted",
  "language",
  "notifications",
  "creditsTitle",
  "openUpgradeOptions",
  "accountMenu",
] as const;

export const toolKeys = [
  "aiMusic",
  "aiCover",
  "vocalRemover",
  "stemSplitter",
] as const;

const navValues: Record<string, readonly string[]> = {
  en: ["Tools", "Create Song", "Create Music Video", "Library", "Pricing", "Blog", "Upgrade", "Get Add-on Credits", "Credit Usage Details", "My Profile", "Manage Subscription", "Log out", "Sign in", "Get started", "Change language", "Notifications", "Credits", "Open upgrade options", "Account menu"],
  es: ["Herramientas", "Crear canción", "Crear video musical", "Biblioteca", "Precios", "Blog", "Mejorar", "Comprar créditos extra", "Detalle de uso de créditos", "Mi perfil", "Gestionar suscripción", "Cerrar sesión", "Iniciar sesión", "Comenzar", "Cambiar idioma", "Notificaciones", "Créditos", "Abrir opciones de mejora", "Menú de cuenta"],
  ja: ["ツール", "曲を作成", "MVを作成", "ライブラリ", "料金", "ブログ", "アップグレード", "追加クレジットを購入", "クレジット利用履歴", "プロフィール", "サブスク管理", "ログアウト", "ログイン", "始める", "言語を変更", "通知", "クレジット", "アップグレードを開く", "アカウントメニュー"],
  pt: ["Ferramentas", "Criar música", "Criar videoclipe", "Biblioteca", "Preços", "Blog", "Upgrade", "Comprar créditos extras", "Detalhes de uso dos créditos", "Meu perfil", "Gerenciar assinatura", "Sair", "Entrar", "Começar", "Mudar idioma", "Notificações", "Créditos", "Abrir opções de upgrade", "Menu da conta"],
  fr: ["Outils", "Créer une chanson", "Créer un clip", "Bibliothèque", "Tarifs", "Blog", "Améliorer", "Acheter des crédits", "Détails d'utilisation", "Mon profil", "Gérer l'abonnement", "Se déconnecter", "Se connecter", "Commencer", "Changer de langue", "Notifications", "Crédits", "Ouvrir les options d'abonnement", "Menu du compte"],
  zh: ["工具", "创作歌曲", "制作音乐视频", "资料库", "价格", "博客", "升级", "购买额外点数", "点数使用详情", "我的资料", "管理订阅", "退出登录", "登录", "开始", "切换语言", "通知", "点数", "打开升级选项", "账户菜单"],
  ko: ["도구", "노래 만들기", "뮤직비디오 만들기", "라이브러리", "요금", "블로그", "업그레이드", "추가 크레딧 구매", "크레딧 사용 내역", "내 프로필", "구독 관리", "로그아웃", "로그인", "시작하기", "언어 변경", "알림", "크레딧", "업그레이드 옵션 열기", "계정 메뉴"],
  id: ["Alat", "Buat lagu", "Buat video musik", "Pustaka", "Harga", "Blog", "Upgrade", "Beli kredit tambahan", "Detail penggunaan kredit", "Profil saya", "Kelola langganan", "Keluar", "Masuk", "Mulai", "Ganti bahasa", "Notifikasi", "Kredit", "Buka opsi upgrade", "Menu akun"],
  it: ["Strumenti", "Crea canzone", "Crea video musicale", "Libreria", "Prezzi", "Blog", "Upgrade", "Acquista crediti extra", "Dettagli uso crediti", "Il mio profilo", "Gestisci abbonamento", "Esci", "Accedi", "Inizia", "Cambia lingua", "Notifiche", "Crediti", "Apri opzioni upgrade", "Menu account"],
  nl: ["Tools", "Song maken", "Muziekvideo maken", "Bibliotheek", "Prijzen", "Blog", "Upgraden", "Extra credits kopen", "Creditgebruik bekijken", "Mijn profiel", "Abonnement beheren", "Uitloggen", "Inloggen", "Starten", "Taal wijzigen", "Meldingen", "Credits", "Upgradeopties openen", "Accountmenu"],
  pl: ["Narzędzia", "Utwórz utwór", "Utwórz teledysk", "Biblioteka", "Cennik", "Blog", "Ulepsz", "Kup dodatkowe kredyty", "Szczegóły użycia kredytów", "Mój profil", "Zarządzaj subskrypcją", "Wyloguj", "Zaloguj", "Zacznij", "Zmień język", "Powiadomienia", "Kredyty", "Otwórz opcje ulepszenia", "Menu konta"],
  tr: ["Araçlar", "Şarkı oluştur", "Müzik videosu oluştur", "Kütüphane", "Fiyatlar", "Blog", "Yükselt", "Ek kredi al", "Kredi kullanım detayları", "Profilim", "Aboneliği yönet", "Çıkış yap", "Giriş yap", "Başla", "Dili değiştir", "Bildirimler", "Krediler", "Yükseltme seçeneklerini aç", "Hesap menüsü"],
  vi: ["Công cụ", "Tạo bài hát", "Tạo video nhạc", "Thư viện", "Giá", "Blog", "Nâng cấp", "Mua thêm credit", "Chi tiết dùng credit", "Hồ sơ của tôi", "Quản lý gói", "Đăng xuất", "Đăng nhập", "Bắt đầu", "Đổi ngôn ngữ", "Thông báo", "Credit", "Mở tuỳ chọn nâng cấp", "Menu tài khoản"],
  de: ["Werkzeuge", "Song erstellen", "Musikvideo erstellen", "Bibliothek", "Preise", "Blog", "Upgrade", "Zusatz-Credits kaufen", "Credit-Verlauf", "Mein Profil", "Abo verwalten", "Abmelden", "Anmelden", "Loslegen", "Sprache ändern", "Benachrichtigungen", "Credits", "Upgrade-Optionen öffnen", "Kontomenü"],
};

const toolValues: Record<string, readonly string[]> = {
  en: ["AI Music", "AI Cover", "Vocal Remover", "Stem Splitter"],
  es: ["Música IA", "Cover IA", "Eliminador de voz", "Separador de pistas"],
  ja: ["AI音楽", "AIカバー", "ボーカル除去", "ステム分離"],
  pt: ["Música IA", "Cover IA", "Removedor de vocal", "Separador de stems"],
  fr: ["Musique IA", "Cover IA", "Suppresseur de voix", "Séparateur de pistes"],
  zh: ["AI 音乐", "AI 翻唱", "人声移除", "分轨工具"],
  ko: ["AI 음악", "AI 커버", "보컬 제거", "스템 분리"],
  id: ["Musik AI", "Cover AI", "Penghapus vokal", "Pemisah stem"],
  it: ["Musica IA", "Cover IA", "Rimuovi voce", "Separatore stem"],
  nl: ["AI-muziek", "AI-cover", "Vocal Remover", "Stem Splitter"],
  pl: ["Muzyka AI", "Cover AI", "Usuwanie wokalu", "Rozdzielanie ścieżek"],
  tr: ["AI Müzik", "AI Cover", "Vokal kaldırıcı", "Stem ayırıcı"],
  vi: ["Nhạc AI", "Cover AI", "Tách giọng", "Tách stem"],
  de: ["KI-Musik", "KI-Cover", "Vocal Remover", "Stem Splitter"],
};

function toRecord<K extends readonly string[]>(
  keys: K,
  values: readonly string[],
): Record<K[number], string> {
  return Object.fromEntries(
    keys.map((key, index) => [key, values[index] ?? ""]),
  ) as Record<K[number], string>;
}

const mapValues = (values: Record<string, readonly string[]>, keys: readonly string[]) =>
  Object.fromEntries(
    Object.entries(values).map(([code, arr]) => [code, toRecord(keys as any, arr)]),
  ) as Record<string, Record<string, string>>;

export const navByLang = mapValues(navValues, navKeys);
export const toolsByLang = mapValues(toolValues, toolKeys);
